/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ToolbarChatActivities_EmbedQuery = {
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityCount_EmbedQuery">;
    readonly " $refType": "ToolbarChatActivities_EmbedQuery";
};
export type ToolbarChatActivities_EmbedQuery$data = ToolbarChatActivities_EmbedQuery;
export type ToolbarChatActivities_EmbedQuery$key = {
    readonly " $data"?: ToolbarChatActivities_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ToolbarChatActivities_EmbedQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToolbarChatActivities_EmbedQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TypographyChatActivityCount_EmbedQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = 'e70a0ed2efac67714f0dc939b6a1291e';
export default node;
